import { Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { useTranslate } from "../../../hooks/useTranslate";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { useStudents } from "../../../context/students";
import TaskCard from "../../../components/TaskCard";

const StudentHub = () => {
    const { t } = useTranslate();
    const navigate = useNavigate();

    const { activeStudentId } = useStudents();

    return (
        <div className="page-content">
            <div className="student-head-section" />
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("studentHub.title"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("studentHub.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("studentHub.subtitle")}
                    </Typography>
                    <Typography variant="h1" component="h2" className="mt-8 text-white">
                        {t("common.quickLinks")}
                    </Typography>
                </Grid2>
            </Grid2>
            <Grid2 container spacing={4} className="mt-4">
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("studentHub.schoolTimetable")}>
                        <Typography variant="body1" component="div">
                            {t("studentHub.schoolTimetableText")}
                        </Typography>
                        <Button
                            onClick={() => navigate(`/student-hub/timetable/${activeStudentId}`)}
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("studentHub.teachingGroupsBios")}>
                        <Typography variant="body1" component="div">
                            {t("studentHub.teachingGroupsBiosText")}
                        </Typography>
                        <Button
                            onClick={() => navigate(`/student-hub/teaching-groups/${activeStudentId}`)}
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("studentHub.schoolCalendar")}>
                        <Typography variant="body1" component="div">
                            {t("studentHub.schoolCalendarText")}
                        </Typography>
                        <Button
                            onClick={() => navigate(`/student-hub/calendar/${activeStudentId}`)}
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
            </Grid2>
        </div>
    );
};

export default StudentHub;
